import {type ReactElement, type ReactNode} from 'react';

import {PageLoader} from './modules/common/components/PageLoader';
import {useOrganisationData} from './modules/common/hooks/useOrganisationData';
import {useOrganisationStore} from './modules/common/stores/organisationStore';
import {SelectOrganisationModel} from './modules/home/components/SelectOrganisationModel';
import {Home} from './modules/home/pages/Home';
import {OrganisationWrapperError} from './OrganisationWrapperError';

interface OrganisationWrapperProps {
  children: ReactNode;
}

export function OrganisationWrapper({
  children,
}: OrganisationWrapperProps): ReactElement | ReactNode | null {
  const {
    organisations: organisationsQuery,
    organisationGroups: organisationGroupQuery,
  } = useOrganisationData();

  const selectedOrganisation = useOrganisationStore(
    (state) => state.organisationId,
  );
  const selectedOrganisationGroup = useOrganisationStore(
    (state) => state.organisationGroupId,
  );

  const isInitialLoading =
    (organisationsQuery.isLoading && !organisationsQuery.data) ||
    (organisationGroupQuery.isLoading && !organisationGroupQuery.data);

  if (isInitialLoading) {
    return <PageLoader message="Loading organisations" />;
  }

  if (organisationsQuery.error ?? organisationGroupQuery.error) {
    return <OrganisationWrapperError />;
  }

  if (!selectedOrganisation || !selectedOrganisationGroup) {
    return (
      <>
        <Home />
        <SelectOrganisationModel open={true} />
      </>
    );
  }

  return children;
}
